import React from "react";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IInvoice, IMeta, ICommonState } from "models/.";
import { URLS } from "constants/urlConstants";
import { columnsExcel } from "./columnsExcel";
import { connect } from "../../reduxConnector";
import InvoiceActions from "./actions";
import { columns } from "./columns";
import InvoicesSearch from "./partials/InvoicesSearch";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  getInvoices: (meta?: IMeta) => void;
  invoices: IInvoice[];
  meta: IMeta;
  history: History;
  purchaseTypes: any[];
  typeOptions: any[];
  getSelectOptions: () => void;
}

interface IState extends ICommonState {
  selectedData: any;
}

class Invoices extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: []
    };
  }

  public componentDidMount() {
    const { typeOptions, getSelectOptions } = this.props;

    if (!typeOptions || !typeOptions.length) {
      getSelectOptions();
    }
  }

  public handleSelect = selectedOption => {
    const { value } = selectedOption;
    const { selectedData } = this.state;
    const ids = _(this.state.checkedRows)
      .keys()
      .map(_.toNumber)
      .value();

    value === "gelezen" && markAsRead(ids, "Factuur");
    value === "ongelezen" && markAsUnread(ids, "Factuur");
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "INVOICES");
      markAsRead(ids, "Factuur");
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser
    }));
  };

  public handleFieldsChange = columnsCopy => {
    this.setState({ columnsCopy });
  };

  public onRowClick = rowData => {
    this.props.history.push(`${URLS.INVOICES_URL}/${rowData.Id}`);

    if (!_.get(rowData, "Read", true)) {
      markAsRead([rowData.Id], "Factuur");
    }
  };

  private onRowSelect = checkedRows => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.invoices,
        checkedRows,
        this.state.selectedData
      )
    });
  };

  public render() {
    const {
      getInvoices,
      invoices,
      meta,
      purchaseTypes,
      typeOptions
    } = this.props;
    const {
      showFieldChooser,
      columnsCopy,
      selectedOption,
      checkedRows
    } = this.state;

    return (
      <div id="invoices-page">
        <FormattedMessage id="INVOICES" tagName="h1" />
        <InvoicesSearch
          meta={meta}
          onSearch={getInvoices}
          roleIds={purchaseTypes}
          typeOptions={typeOptions}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getInvoices({
              ...meta,
              unread: !meta.unread,
              currentPage: 0
            })
          }
          excelColumns={columnsExcel}
          selectedOption={selectedOption}
          getExcelData={() => InvoiceActions.getExportData(meta.searchString)}
          entityName="INVOICES"
        />
        <Table
          columns={columnsCopy}
          dataSource={invoices}
          onRowClick={this.onRowClick}
          meta={meta}
          onQueryChange={getInvoices}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.invoices}
        />
        <FieldChooser
          name="facturen"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    invoices: state.invoices.items,
    meta: state.invoices.meta,
    purchaseTypes: state.invoices.purchaseTypes,
    typeOptions: state.invoices.typeOptions
  }),
  {
    getInvoices: InvoiceActions.getInvoices,
    getSelectOptions: InvoiceActions.getSelectOptions
  }
)(Invoices);
